import React, { useContext, useState } from "react"
import { Link } from "react-router-dom"
import { useNavigateToPost } from "../../hooks/useNavigateToPost"
import { SmartDateFormat } from "../../util/dates"
import CommentSectionPreview from "../comments/CommentSectionPreview"
import { TextAsImage } from "./TextAsImage"
import { PostListItemStyles } from "./constants"
import { ShareUrlButton } from "../ShareUrlButton"
import { ExternalPhotoSrcHeader } from "./ExternalPhotoSrcHeader"
import { ShowHideButton } from "../shared/Button"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import { UserContext } from "../HomeApp"
import HeadlinePostForm from "../HeadlinePostForm"
import ImageVideoAlbumPreview from "../ImageVideoAlbumPreview"
import clsx from "clsx"
import FreeTextFormat from "../shared/FreeTextFormat"
import styles from "./styles.module.css"
import PremiereHeader from "./PremiereHeader"

export const HeadlineListItem = ({
  headline,
  updateStatus,
  adminMode = false,
}) => {
  const [currentHeadline, setCurrentHeadline] = useState(headline)
  const [postStatus, setPostStatus] = useState(headline.status)
  const [showEditForm, setShowEditForm] = useState(false)
  const [deleted, setDeleted] = useState(false)
  const { user } = useContext(UserContext)
  const navigateToPostScreen = useNavigateToPost(currentHeadline.nada_path)

  const description = currentHeadline.original_text
    ? currentHeadline.description
      ? `${currentHeadline.description}:\n${currentHeadline.original_text}`
      : currentHeadline.original_text
    : `Headline from ${currentHeadline.band_name}`

  if (deleted) return null

  return showEditForm ? (
    <HeadlinePostForm
      bandId={user.band_id}
      setShowForm={setShowEditForm}
      post={headline}
      setNewPost={setCurrentHeadline}
      onDeleted={() => setDeleted(true)}
    />
  ) : (
    <div className="grid grid-cols-12">
      {currentHeadline.attached_media ? (
        <ImageVideoAlbumPreview
          attachedMedia={currentHeadline.attached_media}
          onClick={navigateToPostScreen}
        />
      ) : currentHeadline.external_photo_src ? (
        <ExternalPhotoSrcHeader
          externalPhotoSrc={currentHeadline.external_photo_src}
          alt={currentHeadline.title_cleaned || currentHeadline.title}
          onClick={navigateToPostScreen}
          contentDivClassName={PostListItemStyles.contentDiv}
        />
      ) : (
        <TextAsImage
          text={currentHeadline.title_cleaned || currentHeadline.title}
          onClick={navigateToPostScreen}
          className="cursor-pointer"
        />
      )}

      <div className={PostListItemStyles.metaDiv}>
        <PremiereHeader post={currentHeadline} size="small" />
        <div className="flex items-start justify-between">
          <div>
            <h2
              className={clsx(
                PostListItemStyles.header,
                currentHeadline.title.length > 100
                  ? PostListItemStyles.headerLong
                  : PostListItemStyles.headerShort,
                "cursor-pointer",
                currentHeadline.is_bn_premiere && styles.premiereTitle,
                currentHeadline.status === "trashed" && "line-through",
              )}
              onClick={navigateToPostScreen}
            >
              <FreeTextFormat
                text={
                  currentHeadline.title
                    ? currentHeadline.title_cleaned || currentHeadline.title
                    : `New Headline from ${currentHeadline.band_name}`
                }
                expandable={false}
                expanded={false}
                linkify={true}
              />
            </h2>
          </div>
          <ShareUrlButton
            nadaUrl={currentHeadline.nada_url}
            renderMode="icon"
          />
        </div>

        <Link
          className={PostListItemStyles.bandName}
          to={currentHeadline.local_path}
        >
          {currentHeadline.band_name}
        </Link>
        <h3 className={PostListItemStyles.postDate}>
          Posted:&nbsp;
          {SmartDateFormat({
            dateStr: currentHeadline.published_at,
            includeTime: false,
          })}
        </h3>
        {adminMode && (
          <ShowHideButton
            updateStatus={updateStatus}
            postStatus={postStatus}
            setPostStatus={setPostStatus}
          />
        )}
        <div className="text-sm text-gray-500 mt-2">
          <FreeTextFormat
            text={description}
            expandable={false}
            expanded={false}
            linkify={false}
          />
        </div>

        <div className="mt-4">
          <RelatedPosts postId={currentHeadline.id} />
        </div>
        <div className="mt-6">
          <ReactionBlock
            contentType="Post"
            contentId={currentHeadline.id}
            postId={currentHeadline.id}
          />
        </div>
        <CommentSectionPreview
          postId={currentHeadline.id}
          postPath={currentHeadline.nada_url}
        />
      </div>
    </div>
  )
}
